import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Calendar, Share2, Sparkles, Utensils } from "lucide-react";
import { API } from "@/contexts/AuthContext";

export default function Dashboard() {
  const [plans, setPlans] = useState(null);
  useEffect(() => {
    let active = true;
    (async () => {
      try { const { data } = await axios.get(`${API}/plans`); if (active) setPlans(data); }
      catch { if (active) setPlans([]); }
    })();
    return () => { active = false; };
  }, []);

  return (
    <main className="max-w-5xl mx-auto px-4 sm:px-8 pt-8 pb-24">
      <div className="mb-8 sm:mb-10">
        <div className="text-xs uppercase tracking-[0.2em] text-[#C06F52] mb-2">Your plans</div>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-[#2C4C3B] leading-tight">Every bowl, on record.</h1>
        <p className="text-[#666] mt-2 max-w-md">Browse past plans, copy share links, or start something new.</p>
      </div>

      {plans === null && <p className="text-sm text-[#888]">Loading…</p>}
      {plans?.length === 0 && (
        <div className="rounded-[1.5rem] bg-[#F2EFE9] border border-[#E5E2DC] p-10 text-center">
          <Sparkles size={20} className="text-[#C06F52] mx-auto mb-3" />
          <h2 className="font-serif-display text-2xl text-[#2C4C3B] mb-2">No plans yet.</h2>
          <p className="text-sm text-[#666] mb-5">Build your first meal plan and it'll show up here.</p>
          <Link to="/" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#2C4C3B] text-white text-sm hover:bg-[#1E3629] transition-colors">
            Make a plan →
          </Link>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {plans?.map((p) => (
          <article key={p.id} className="bg-white rounded-[1.5rem] border border-[#E5E2DC] p-6 hover:-translate-y-1 transition-transform">
            <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.18em] text-[#888] mb-3">
              <span className="inline-flex items-center gap-1"><Calendar size={11} />{new Date(p.created_at).toLocaleDateString()}</span>
              <span>{p.days?.length || 1} day{(p.days?.length || 1) > 1 ? "s" : ""}</span>
            </div>
            <h3 className="font-serif-display text-xl text-[#2C4C3B] mb-2">
              {p.days?.[0]?.meals?.[0]?.name || "Meal plan"}
            </h3>
            <div className="text-sm text-[#666] flex flex-wrap gap-3 mb-4">
              <span className="inline-flex items-center gap-1"><Utensils size={12} />{p.targets?.daily_target_kcal} kcal/day</span>
              <span>·</span>
              <span>{p.targets?.protein_target_g} g protein</span>
            </div>
            {p.share_id && (
              <div className="flex items-center gap-2 text-[11px] text-[#888]">
                <Share2 size={11} />
                <span className="break-all">{window.location.origin}/share/{p.share_id}</span>
              </div>
            )}
          </article>
        ))}
      </div>
    </main>
  );
}
